import { connect } from 'react-redux';
import {
    vendorInformation,
    vendorInformationLoad,
    vendorInformationRemove,
    createEventThunk,
    rejectEventThunk,
    approveEventThunk,
    requestInfoEventThunk,
    updateEventThunk,
    createAndSubmitEventThunk,
    updateAndSubmitEventThunk,
    resetEvent,
    setInvalidTabs,
    toggleEventRejectModal,
    toggleEventRequestModal,
    setEventUserAction,
    setEventErrorMessage,
    createAndStoreVendor,
    updateAndStoreVendor,
    createAndAssignVendor,
    updateAndAssignVendor
} from '../../../actions';

import VendorInformation from '../../../components/event/vendor-information';

import {
    getJwtToken,
    getEventActions,
    getEventStatus
} from '../../../reducers';

const mapStateToProps = state => ({
    jwtToken: getJwtToken(state),
    vendorInformationData: state.event.vendorsInformation,
    eventActions: getEventActions(state),
    status: getEventStatus(state),
    userInfo: state.data.userInfo,
    hasActions: state.events.hasActions,
    contract: state.forms.event.contract,
    eventId: state.events.id,
    rejectModalActive: state.events.rejectModalActive,
    requestModalActive: state.events.requestModalActive,
    userAction: state.events.userAction,
    approvers: state.events.approvers,
    tasks: state.events.tasks,
    canSaveSubmit: false,
    canEdit: state.events.eventSaveSubmit,
    eventApproveReject: false,
    prComplete: state.events.prComplete,
    showVendorInfo: state.events.eventApproveReject
});

const mapDispatchToProps = dispatch => ({
    vendorInformation: object => dispatch(vendorInformation(object)),
    vendorInformationLoad: object => dispatch(vendorInformationLoad(object)),
    vendorInformationRemove: index => dispatch(vendorInformationRemove(index)),
    createEvent: (data, vendors) => dispatch(createEventThunk(data, vendors)),
    rejectEvent: data => dispatch(rejectEventThunk(data)),
    approveEvent: data => dispatch(approveEventThunk(data)),
    requestInfoEvent: data => dispatch(requestInfoEventThunk(data)),
    updateEvent: (data, vendors) => dispatch(updateEventThunk(data, vendors)),
    resetEvent: () => dispatch(resetEvent()),
    createAndSubmitEvent: (data, vendors) =>
        dispatch(createAndSubmitEventThunk(data, vendors)),
    updateAndSubmitEvent: (data, vendors) =>
        dispatch(updateAndSubmitEventThunk(data, vendors)),
    setInvalidTabs: e => dispatch(setInvalidTabs(e)),
    toggleRejectModal: () => dispatch(toggleEventRejectModal()),
    toggleRequestModal: () => dispatch(toggleEventRequestModal()),
    setEventUserAction: action => dispatch(setEventUserAction(action)),
    setEventErrorMessage: text => dispatch(setEventErrorMessage(text)),
    createAndStoreVendor: vendor => dispatch(createAndStoreVendor(vendor)),
    updateAndStoreVendor: vendor => dispatch(updateAndStoreVendor(vendor)),
    createAndAssignVendor: vendor => dispatch(createAndAssignVendor(vendor)),
    updateAndAssignVendor: vendor => dispatch(updateAndAssignVendor(vendor))
});

export default connect(mapStateToProps, mapDispatchToProps)(VendorInformation);



// WEBPACK FOOTER //
// ./src/containers/event/vendor-information/purchase-request.js